import WorkAllocationColumn from '@/Pages/WorkAllocation/WorkAllocationColumn'

const WorkAllocationTab = {
    tabMenu: [
        {
            tabName: 'Pending',
            permissions: [],

        },
        {
            tabName: 'Completed',
            permissions: [],
        },
        {
            tabName: 'Locked',
            permissions: [],
        },
        {
            tabName: 'Coding Post Problem',
            permissions: [],
            
        },
        {
            tabName: 'Appeals',
            permissions: [],
        },
        {
            tabName: 'Technical Issue',
            permissions: [],
        },
        {
            tabName: 'Hold',
            permissions: [],
        },
        {
            tabName: 'Ready For Lock',
            permissions: [],
        },
    ],
}
Object.freeze(WorkAllocationTab)
export default WorkAllocationTab
